import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import {
  Upload,
  Button,
  Icon,
  Modal,
  message,
  notification,
  Tooltip,
} from 'antd'
import PropTypes from 'prop-types'
const { confirm } = Modal

class UploadDir extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fileList: [],
      uploading: false,
      trainingConfirmModalShow: false,
      uploadFileCount: null,
      MAX_FILES_LIMIT: -999,
    }
  }

  componentDidMount() {
    this.setState({ classIndex: this.props.classIndex })
  }

  handleUpload = () => {
    if (this.state.fileList.length > 0) {
      this.setState(
        {
          uploading: true,
        },
        () => {
          this.props.handleSuccess({
            fileList: this.state.fileList,
            classIndex: this.state.classIndex,
          })
          this.setState({
            fileList: [],
            uploading: false,
          })
        },
      )
    }
  }

  clearUploadedDir = () => {
    this.setState({ trainingConfirmModalShow: false })
    if (this.state.fileList.length > 0) {
      this.setState(
        {
          uploading: true,
        },
        () => {
          this.setState({
            fileList: [],
            uploading: false,
          })
        },
      )
    }
  }

  showAcceptedFormatMessage = () => {
    if (this.state.fileList.length === 0) {
      // message.warning(
      //   'Important! Only .png and .jpg images are supported. Make sure the directory contains only the supported types of images.',
      // )
      // notification['warning']({
      //   message:
      //     'Important! Only .png and .jpg images are supported. Make sure the directory contains only the supported types of images.',
      //   duration: 8,
      //   placement: 'bottomRight',
      // })
    }
  }

  render() {
    const { style = {} } = this.props
    const { uploading, fileList, trainingConfirmModalShow } = this.state
    const props = {
      onRemove: file => {
        this.setState(state => {
          const index = state.fileList.indexOf(file)
          const newFileList = state.fileList.slice()
          newFileList.splice(index, 1)
          return {
            fileList: newFileList,
          }
        })
      },
      beforeUpload: (file, fileList) => {
        if (
          file.type !== 'image/png' &&
          file.type !== 'image/jpg' &&
          file.type !== 'image/jpeg'
        ) {
          notification.destroy()
          notification['error']({
            message:
              'Error! One or more of the uploaded files are not valid images. Only .png and .jpg images are supported.',
            duration: 4.6,
            placement: 'bottomRight',
          })
          return false
        } else {
          this.setState(state => ({
            fileList: [...state.fileList, file],
          }))
        }
      },
      fileList,
    }

    return (
      <Fragment>
        <Modal
          className="trainingStartConfirmModal"
          title={
            <div style={{ color: '#1890ff' }}>
              <Icon type="question-circle" /> Begin training for Class:{' '}
              <strong>
                {this.props.classLabelObject[this.props.classIndex]}
              </strong>{' '}
              using the uploaded images?
            </div>
          }
          visible={fileList.length > 0 && !trainingConfirmModalShow}
          onOk={this.handleUpload}
          onCancel={this.clearUploadedDir}
          footer={[
            <Button key="cancel" type="default" onClick={this.clearUploadedDir}>
              Cancel
            </Button>,
            <Button key="submit" type="primary" onClick={this.handleUpload}>
              Start Training
            </Button>,
          ]}
        >
          <p>
            Depending on the # of uploaded files and their sizes, this process
            may take a while.
          </p>
        </Modal>
        <Upload
          {...props}
          directory
          showUploadList={false}
          disabled={fileList.length > 0}
        >
          <Tooltip
            placement="bottom"
            title={`Upload training images for class`}
          >
            <Button
              style={{
                ...style,
              }}
              loading={uploading}
              onClick={this.showAcceptedFormatMessage}
            >
              <Icon type="upload" />
              Images
            </Button>
          </Tooltip>
        </Upload>
      </Fragment>
    )
  }
}

UploadDir.propTypes = {
  style: PropTypes.object,
  handleError: PropTypes.func,
  handleSuccess: PropTypes.func,
  classIndex: PropTypes.string.isRequired,
}
export default withRouter(UploadDir)
